export const isEmail = (text) => {
  if (typeof text !== "string") {
    return false;
  }

  const normalizedEmail = text.trim();
  if (!normalizedEmail) {
    return false;
  }

  // Flexible validation to support modern domains and common aliases (e.g. user+tag@domain.info).
  const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailValidationRegex.test(normalizedEmail);
};